module.exports = __webpack_public_path__ + "img/btn-playnow.3d28ae97.png";